import { FormlyFieldConfig } from '@ngx-formly/core';

export function minLengthValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return `Must have at least ${field.props?.minLength} characters`;
}
